import React from 'react';
import BasicCheckBox from '../Basic/BasicCheckBox';

function RoundClean({
    changeFieldsMultiple,
    countIndex,
    checked,
    field,
}) {
    const handleChange = (value) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field,
                value,
            },
        ]);
    };

    return (
        <BasicCheckBox 
            handleChange={handleChange}
            checked={checked}
            labelStyle={{ display: 'none' }}
        />
    );
}

export default React.memo(RoundClean);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/RoundClean.jsx